import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const GetQuizFirstAttemptSlice = createSlice({
    name: "quizFirstAttemptStats",
    initialState,
    reducers: {
        quizFirstAttemptRequest(state) {
            state.loading = true;
        },
        quizFirstAttemptSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        quizFirstAttemptError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
        quizFirstAttemptReset(state) {
            state.loading = false;
            state.error = undefined;
            state.response = undefined;
        },
    },
});

export const {
    quizFirstAttemptRequest,
    quizFirstAttemptSuccess,
    quizFirstAttemptError,
    quizFirstAttemptReset,
} = GetQuizFirstAttemptSlice.actions;

export default GetQuizFirstAttemptSlice.reducer;